import React, { Component } from 'react'
import {Redirect} from 'react-router-dom'
import axios from 'axios'
import {firebase_url} from './config'
// import './confirm.css'
// import './forgot.css'
import './styles/title.css'
import './styles/subtitle.css'
import './styles/inputs.css'
import './styles/button.css'
import './styles/error-message.css'


class Forgot extends Component {
  state = {
    errorMessage: null,
    errorCode: null,
    redirect: false,
    email: '',
    isLoading: false
  };
  sendForgotEmail = event => {
    event.preventDefault();
    this.setState({
      errorMessage: null,
      errorCode: null,
      isLoading: true
    });
    let loader = document.getElementsByClassName('loader')[0];
    loader.style.display = 'block';
    axios.post(`${firebase_url}/forgot-password`, {email: this.state.email})
    .then(res => {
      if (res.status === 200) {
        localStorage.setItem('last_submitted_email', this.state.email);
        this.setState({redirect: true})
      }
    }).catch(error => {
      if ('response' in error) {
          if (error.response.status === 400) {
              console.log(error.response.status);
              this.setState({
                  errorMessage: 'There was an issue with the email you provided.',
                  errorCode: error.response.status,
                  isLoading: false
              });
          } else {
            this.setState({
                errorMessage: error.response.statusText,
                errorCode: error.response.status,
                isLoading: false
            });
          }
      }
      loader.style.display = 'none'
    })
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to="/reset-confirm"/>
    }
    return <div className="content__box">
        <form onSubmit={this.sendForgotEmail}>
          <h1 className="title">Reset your password</h1>
          <p className="subtitle">To reset your password, enter the email address you<br />use to sign in to Community and Courses.</p>

          {
            this.state.errorCode && <div className="error-message"> {this.state.errorMessage} </div>
          }
          <div className="inputs">
            <div className="inputs__field-wrap">
              <input className="inputs__input" type="text" placeholder="Email address" name="email" id='email' value={this.state.email} onChange={evt => this.setState({email: evt.target.value.trim()})}/>
            </div>
          </div>

          <div>
            <button className="button" disabled={this.state.isLoading}><div>Get reset link</div><div className="loader"/></button>
          </div>
        </form>
      </div>

  }
}

export default Forgot



// WEBPACK FOOTER //
// ./src/forgot.js